"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _setDelayModal = _interopRequireDefault(require("./set-delay-modal"));
var _confirmDelay = _interopRequireDefault(require("./confirm-delay"));
var _constants = require("../../../../../../stripe/constants");
var _occasion = _interopRequireDefault(require("occasion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // This displays the appropriate button to allow the user to offer a place to a
const defaultState = {
  settingDelay: false,
  checkingDelay: false,
  requestedDelay: null
};
class ChargeDate extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", defaultState);
    _defineProperty(this, "_onToggleSetDelay", () => {
      if (!this.state.settingDelay) return this.setState({
        settingDelay: true
      });
      return this.setState(defaultState);
    });
    _defineProperty(this, "_onToggleCheckDelay", () => {
      this.setState({
        checkingDelay: !this.state.checkingDelay
      });
    });
    _defineProperty(this, "_getDelay", () => {
      return this.state.requestedDelay !== null ? this.state.requestedDelay : this.props.competition.daysToDelayCharging;
    });
    _defineProperty(this, "_setDelay", value => {
      this.setState({
        requestedDelay: value
      });
    });
    _defineProperty(this, "_getNewChargeDate", () => {
      const startDate = new Date(this.props.competition.startDate);
      const delay = +this.state.requestedDelay || 0;
      return new Date(startDate.setDate(startDate.getDate() - _constants.chargeLeadTime + delay)).toISOString().split('T')[0];
    });
    _defineProperty(this, "_validateDelay", () => {
      const today = new Date().toISOString().split('T')[0];
      const newChargeDate = this._getNewChargeDate();
      const delay = +this.state.requestedDelay || 0;
      if (delay > _constants.chargeLeadTime - 2) return 'Cannot delay by more than ' + (_constants.chargeLeadTime - 2) + ' days';
      if (newChargeDate <= today) return 'Tomorrow is the earliest charge date you can set';
      if (newChargeDate >= this.props.competitionStartDate) return 'You must charge before the competition starts';
      return;
    });
    _defineProperty(this, "_onConfirmDelay", () => {
      return this.props.onUpdateCompetition(this.props.competition.id, 'daysToDelayCharging', this.state.requestedDelay).then(() => this.setState(defaultState));
    });
  }
  render() {
    const competition = this.props.competition;
    const today = new Date().toISOString().split('T')[0];
    return /*#__PURE__*/_react.default.createElement("span", null, competition.paymentsChargeDate < today ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "card-footer"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Paddlers will be charged on ", (0, _occasion.default)(competition.paymentsChargeDate, 'D MMMM YYYY')), !this.props.userIsSystemAdmin ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleSetDelay
    }, "Delay Charge"), this.state.checkingDelay ? /*#__PURE__*/_react.default.createElement(_confirmDelay.default, {
      competition: this.props.competition,
      delay: this.state.requestedDelay,
      newChargeDate: this._getNewChargeDate(),
      error: this._validateDelay(),
      closeCancel: this._onToggleSetDelay,
      back: this._onToggleCheckDelay,
      confirm: this._onConfirmDelay
    }) : !this.state.settingDelay ? null : /*#__PURE__*/_react.default.createElement(_setDelayModal.default, {
      delay: this._getDelay(),
      next: this._onToggleCheckDelay,
      setDelay: this._setDelay,
      closeCancel: this._onToggleSetDelay,
      competition: this.props.competition
    }))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(ChargeDate, "partialQueries", {
  Competition: _mergeBqlQueries(_mergeBqlQueries({
    id: true,
    paymentsChargeDate: true,
    daysToDelayCharging: true,
    startDate: true
  }, _setDelayModal.default.partialQueries.Competition), _confirmDelay.default.partialQueries.Competition)
});
var _ref = {
  userIsSystemAdmin: true
};
var _default = exports.default = (0, _reactBicycle.connect)(ChargeDate, () => _ref, (client, props) => ({
  onUpdateCompetition(id, field, value) {
    return client.update('Competition.set', {
      id,
      field,
      value
    });
  }
}));